import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'invoiceStatus'
})
export class InvoiceStatusPipe implements PipeTransform {

  transform(value: string, lang: string = 'fa'): any {
    const paid = (lang === 'fa' ? 'پرداخت شده' : 'Paid');
    const used = (lang === 'fa' ? 'مصرف شده' : 'Used');
    const canceled = (lang === 'fa' ? 'لغو شده' : 'Canceled');
    const draft = (lang === 'fa' ? 'پیش نویس' : 'Draft');
    switch (value) {
      case 'P':
        return paid;
      case 'D':
        return draft;
      case 'U':
        return used;
      case 'C':
        return canceled;
    }
  }

}
